/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Fleet_RotatingInputs */

const vi_station_fleet_rotating = /** @type {(inputs: Station_Fleet_RotatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tự xoay vòng`)
};

/**

* @param {Station_Fleet_RotatingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_fleet_rotating = /** @type {((inputs?: Station_Fleet_RotatingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Fleet_RotatingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_fleet_rotating(inputs)
});